import { isArray } from 'lodash';
import { ACTIONS } from '../Constants';

const initialState = {
    byParentId: {},
    filteredById: {},
    loading: false
};

const userResponses = (state = initialState, action) => {
    let newById;
    let reduced;

    switch (action.type) {
        case ACTIONS.PUT_USER_RESPONSE_START:
        case ACTIONS.PUT_USER_RESPONSE:
        case ACTIONS.POST_USER_RESPONSE: {
            const { userResponses } = action.payload;

            const userResponseArray = isArray(userResponses) ? userResponses : [userResponses];

            reduced = userResponseArray.reduce((prev, userResponsesItem) => {
                prev[userResponsesItem.parentId] = userResponsesItem;
                return prev;
            }, {});

            newById = {
                ...state.byParentId,
                ...reduced
            };

            return {
                ...state,
                byParentId: newById
            };
        }
        default:
            return state;
    }
};

export default userResponses;
